<template>
  <v-container class="coverage-section py-8 py-md-12">
    <v-row class="text-center mb-6 mb-md-10 fade-slide-down">
      <v-col cols="12" md="10" lg="8" class="mx-auto">
        <div class="section-badge mb-1">Coberturas</div>

        <h2 class="header-title mb-1">
          Las coberturas perfectas para ti y tu familia
        </h2>

        <p class="header-subtitle mb-0">
          Consulta externa, urgencias médicas, dental y visual.
          <br class="d-none d-md-block" />
          Protección real para lo que sí importa.
        </p>
      </v-col>
    </v-row>

    <v-row class="justify-center" dense>
      <v-col
        v-for="(item, i) in coberturas"
        :key="`cobertura-${i}`"
        cols="12"
        sm="6"
        md="3"
        class="px-2 py-2"
        :style="{ animationDelay: `${i * 0.12}s` }"
      >
        <v-card
          class="coverage-card text-center d-flex flex-column align-center"
          flat
          @mouseenter="hoverIndex = i"
          @mouseleave="hoverIndex = null"
          :class="{ 'coverage-card--active': hoverIndex === i }"
        >
          <div class="icon-wrapper mb-4" :class="{ 'icon-wrapper--active': hoverIndex === i }">
            <v-icon
              size="34"
              color="primary"
              class="coverage-icon"
              :class="{ 'coverage-icon--active': hoverIndex === i }"
            >
              {{ item.icon }}
            </v-icon>
          </div>

          <h3 class="coverage-title mb-2">
            {{ item.titulo }}
          </h3>

          <p class="coverage-description mb-0">
            {{ item.descripcion }}
          </p>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "SeccionCobComponent",
  data() {
    return {
      hoverIndex: null,
      coberturas: [
        {
          icon: "mdi-stethoscope",
          titulo: "Consulta Médica",
          descripcion: "Atención con médicos especialistas certificados."
        },
        {
          icon: "mdi-hospital",
          titulo: "Urgencias Médicas",
          descripcion: "Cobertura para emergencias por enfermedad o accidente."
        },
        {
          icon: "mdi-tooth-outline",
          titulo: "Atención Dental",
          descripcion: "Servicios dentales con especialistas en ortodoncia y más."
        },
        {
          icon: "mdi-glasses",
          titulo: "Salud Visual",
          descripcion: "Exámenes de la vista y lentes a precios preferentes."
        }
      ]
    };
  }
};
</script>

<style scoped>
.coverage-section {
  background: linear-gradient(180deg, #ffffff 0%, #faf8ff 100%);
  border-radius: 24px;
}

.section-badge {
  display: inline-block;
  padding: 6px 14px;
  border-radius: 999px;
  background: #ede7f6;
  color: #5e35b1;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.4px;
}

/* Entrada del bloque principal */
.fade-slide-down {
  opacity: 0;
  transform: translateY(-24px);
  animation: fadeSlideDown 0.8s ease forwards;
}

@keyframes fadeSlideDown {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Card */
.coverage-card {
  height: 100%;
  min-height: 220px;
  padding: 28px 20px;
  border-radius: 22px;
  background: #ffffff;
  border: 1px solid #f1f1f4;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
  opacity: 0;
  transform: translateY(24px);
  animation: fadeInUp 0.55s ease forwards;
  transition:
    transform 0.28s ease,
    box-shadow 0.28s ease,
    border-color 0.28s ease,
    background-color 0.28s ease;
  will-change: transform;
}

.coverage-card:hover,
.coverage-card--active {
  transform: translateY(-8px);
  box-shadow: 0 16px 34px rgba(94, 53, 177, 0.14);
  border-color: #d9c8ff;
  background: linear-gradient(180deg, #ffffff 0%, #f8f4ff 100%);
}

.icon-wrapper {
  width: 68px;
  height: 68px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f4efff;
  transition: transform 0.28s ease, background-color 0.28s ease;
}

.icon-wrapper--active,
.coverage-card:hover .icon-wrapper {
  transform: scale(1.08);
  background: #ede3ff;
}

.coverage-icon {
  transition: transform 0.28s ease;
}

.coverage-icon--active,
.coverage-card:hover .coverage-icon {
  transform: scale(1.12);
}

.coverage-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #1f2937;
  line-height: 1.35;
}

.coverage-description {
  font-size: 0.95rem;
  line-height: 1.6;
  color: #6b7280;
}

/* Animación cards */
@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Móvil */
@media (max-width: 600px) {
  .coverage-section {
    border-radius: 18px;
  }

  .coverage-card {
    min-height: auto;
    padding: 24px 18px;
  }

  .header-subtitle br {
    display: none;
  }
}
</style>